<template>
  <div class="ab-chips">
    <span class="ab-lab">тесты</span>
    <span v-for="t in live" :key="t.id" class="ab-tset">
      <button type="button" :title="t.hypothesis || 'открыть срез теста'" @click="$emit('open', t)">
        <i class="ab-tg">{{ t.kind === 'prepost' ? 'д/п' : 'A/B' }}</i>{{ t.name }}
      </button>
      <button type="button" class="ab-te" aria-label="правка" @click="$emit('edit', t)">✎</button>
      <button type="button" class="ab-tx" aria-label="убрать" @click="$emit('delete', t.id)">×</button>
    </span>
    <!-- Каждая кнопка открывает свою вкладку отчёта: счётчик виден, не заходя в отчёт. -->
    <button type="button" class="ab-run" @click="$emit('report', 'run')">запущенные ({{ live.length }})</button>
    <button type="button" class="ab-run" @click="$emit('report', 'done')">завершённые ({{ tests.length - live.length }})</button>
  </div>
</template>

<script>
export default {
  name: 'AbChips',
  props: {
    tests: { type: Array, required: true },           // К8[]
  },
  emits: ['open', 'edit', 'delete', 'report'],
  computed: {
    // В строке только идущие: чип нужен, чтобы вернуться в срез теста, с которым работаешь.
    live() { return this.tests.filter(t => t.finishedAt == null); },
  },
};
</script>

<style>
.ins-root .ab-chips{display:flex; flex-wrap:wrap; align-items:center; gap:6px; margin:2px 0 10px; font-size:12px; line-height:1.4;}
.ins-root .ab-chips .ab-lab{color:var(--text-muted); font-size:11.5px;}
.ins-root .ab-tset{display:inline-flex; align-items:center; border:1px solid var(--border); border-radius:999px; background:var(--surface-1); overflow:hidden;}
.ins-root .ab-tset button, .ins-root .ab-run{border:0; background:transparent; color:var(--text-secondary); font:inherit; font-size:11.5px;
  padding:3px 9px; cursor:pointer;}
.ins-root .ab-tset button:hover{color:var(--text-primary);}
.ins-root .ab-tset .ab-te, .ins-root .ab-tset .ab-tx{color:var(--text-muted); padding:3px 7px; border-left:1px solid var(--border);}
.ins-root .ab-run{border:1px solid var(--accent); border-radius:20px; background:none; color:var(--accent); font-size:11.5px;
  font-weight:600; padding:3px 11px; margin-left:4px;}
.ins-root .ab-run:hover{background:var(--accent); color:var(--on-accent);}
.ins-root .ab-tg{font-style:normal; font-size:9.5px; font-weight:700; letter-spacing:.02em; color:var(--accent); border:1px solid var(--accent); border-radius:4px;
  padding:1px 3px; margin-right:6px; vertical-align:1px;}
</style>
